// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal {
	display: block !important;
	background-color: #5050506e;
}

.modal .modal-header {
	background: steelblue;
	padding: 0.1rem;
	color: whitesmoke;
}

.detail-modal .paginator-button {
	--bs-btn-hover-color: white;
	--bs-btn-hover-bg: transparent;
	--bs-btn-border-color: transparent;
	--bs-btn-hover-border-color: transparent;
	--bs-btn-active-bg: transparent;
	--bs-btn-color: #ffffffbf;
	--bs-btn-active-color: #ffffffbf;
}

.detail-modal .paginator-button.disabled {
	border-color: transparent;
}

.detail-modal .close-button {
	--bs-btn-close-hover-opacity: 1 !important;
	--bs-btn-close-opacity: 0.5 !important;
}

.detail-modal .paginator-arrow {
	font-weight: bolder;
	font-size: 2rem !important;
	margin-bottom: 0.25rem !important;
}

.form-floating > label {
	background-color: transparent !important;
}

.form-floating > .form-control:not(:placeholder-shown) ~ label::after {
	background-color: transparent !important;
}

.was-validated :invalid ~ .form-text .invalid-feedback,
.is-invalid ~ .form-text .invalid-feedback {
	display: inline;
	font-weight: bold;
}
`, "",{"version":3,"sources":["webpack://./src/styles/detailmodal.css"],"names":[],"mappings":"AAAA;CACC,yBAAyB;CACzB,2BAA2B;AAC5B;;AAEA;CACC,qBAAqB;CACrB,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,2BAA2B;CAC3B,8BAA8B;CAC9B,kCAAkC;CAClC,wCAAwC;CACxC,+BAA+B;CAC/B,yBAAyB;CACzB,gCAAgC;AACjC;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,0CAA0C;CAC1C,sCAAsC;AACvC;;AAEA;CACC,mBAAmB;CACnB,0BAA0B;CAC1B,iCAAiC;AAClC;;AAEA;CACC,wCAAwC;AACzC;;AAEA;CACC,wCAAwC;AACzC;;AAEA;;CAEC,eAAe;CACf,iBAAiB;AAClB","sourcesContent":[".modal {\n\tdisplay: block !important;\n\tbackground-color: #5050506e;\n}\n\n.modal .modal-header {\n\tbackground: steelblue;\n\tpadding: 0.1rem;\n\tcolor: whitesmoke;\n}\n\n.detail-modal .paginator-button {\n\t--bs-btn-hover-color: white;\n\t--bs-btn-hover-bg: transparent;\n\t--bs-btn-border-color: transparent;\n\t--bs-btn-hover-border-color: transparent;\n\t--bs-btn-active-bg: transparent;\n\t--bs-btn-color: #ffffffbf;\n\t--bs-btn-active-color: #ffffffbf;\n}\n\n.detail-modal .paginator-button.disabled {\n\tborder-color: transparent;\n}\n\n.detail-modal .close-button {\n\t--bs-btn-close-hover-opacity: 1 !important;\n\t--bs-btn-close-opacity: 0.5 !important;\n}\n\n.detail-modal .paginator-arrow {\n\tfont-weight: bolder;\n\tfont-size: 2rem !important;\n\tmargin-bottom: 0.25rem !important;\n}\n\n.form-floating > label {\n\tbackground-color: transparent !important;\n}\n\n.form-floating > .form-control:not(:placeholder-shown) ~ label::after {\n\tbackground-color: transparent !important;\n}\n\n.was-validated :invalid ~ .form-text .invalid-feedback,\n.is-invalid ~ .form-text .invalid-feedback {\n\tdisplay: inline;\n\tfont-weight: bold;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
